import { MLData, MLPageData } from '../../../../datasets/store/mlTypes';
import { SingleDatasetFieldType } from '../../../../datasets/store/types';
import { AnalysisView } from '../../../../documents/store/types';
import { ColumnSort, TableFilters } from '../../../../shared/table/types';
import { AgreementType } from '../../../documents/store/types';

export enum AdminAIPlaygroundActionTypes {
    FETCH_ML_TEST_DOCUMENTS_STARTED = 'FETCH_ML_TEST_DOCUMENTS_STARTED',
    FETCH_ML_TEST_DOCUMENTS_SUCCESSFUL = 'FETCH_ML_TEST_DOCUMENTS_SUCCESSFUL',
    FETCH_ML_TEST_DOCUMENTS_FAILED = 'FETCH_ML_TEST_DOCUMENTS_FAILED',
    SET_ML_TEST_DOCUMENTS_TABLE_FILTERS = 'SET_ML_TEST_DOCUMENTS_TABLE_FILTERS',
    CLEAR_ML_TEST_DOCUMENTS_TABLE_FILTERS = 'CLEAR_ML_TEST_DOCUMENTS_TABLE_FILTERS',
    SET_ML_TEST_DOCUMENTS_TABLE_COLUMN_SORT = 'SET_ML_TEST_DOCUMENTS_TABLE_COLUMN_SORT',
    SET_ML_TEST_DOCUMENTS_PAGE_SIZE = 'SET_ML_TEST_DOCUMENTS_PAGE_SIZE',
    ML_TEST_DOCUMENTS_PAGINATION_NEXT = 'ML_TEST_DOCUMENTS_PAGINATION_NEXT',
    ML_TEST_DOCUMENTS_PAGINATION_PREVIOUS = 'ML_TEST_DOCUMENTS_PAGINATION_PREVIOUS',
    UPLOAD_ML_TEST_DOCUMENT_MODAL_OPEN = 'UPLOAD_ML_TEST_DOCUMENT_MODAL_OPEN',
    UPLOAD_ML_TEST_DOCUMENT_STARTED = 'UPLOAD_ML_TEST_DOCUMENT_STARTED',
    UPLOAD_ML_TEST_DOCUMENT_SUCCESSFUL = 'UPLOAD_ML_TEST_DOCUMENT_SUCCESSFUL',
    UPLOAD_ML_TEST_DOCUMENT_FAILED = 'UPLOAD_ML_TEST_DOCUMENT_FAILED',
    SET_INITIAL_UPLOAD_ML_TEST_DOCUMENTS = 'SET_INITIAL_UPLOAD_ML_TEST_DOCUMENTS',
    UPDATE_ML_TEST_DOCUMENT_NAME = 'UPDATE_ML_TEST_DOCUMENT_NAME',
    OPEN_ML_TEST_DOCUMENT_STARTED = 'OPEN_ML_TEST_DOCUMENT_STARTED',
    OPEN_ML_TEST_DOCUMENT_SUCCESSFUL = 'OPEN_ML_TEST_DOCUMENT_SUCCESSFUL',
    OPEN_ML_TEST_DOCUMENT_FAILED = 'OPEN_ML_TEST_DOCUMENT_FAILED',
    TOGGLE_ML_TEST_DOCUMENT_ANALYSIS_VIEW = 'TOGGLE_ML_TEST_DOCUMENT_ANALYSIS_VIEW',
    RESET_ML_TEST_DOCUMENT = 'RESET_ML_TEST_DOCUMENT',
    SCHEDULE_START_AND_END_PAGE_UPDATE_VALUE = 'SCHEDULE_START_AND_END_PAGE_UPDATE_VALUE',
    TOGGLE_PLAYGROUND_QUESTION = 'TOGGLE_PLAYGROUND_QUESTION',
    UPDATE_AI_PLAYGROUND_SEARCH = 'UPDATE_AI_PLAYGROUND_SEARCH',
    SET_SCHEDULE_PAGE = 'SET_SCHEDULE_PAGE',
    UPDATE_SELECTED_DOCUMENT_QUERY = 'UPDATE_SELECTED_DOCUMENT_QUERY',
    ADD_NEW_PLAYGROUND_DOCUMENT_QUERY = 'ADD_NEW_PLAYGROUND_DOCUMENT_QUERY',
    DELETE_PLAYGROUND_DOCUMENT_QUERY = 'DELETE_PLAYGROUND_DOCUMENT_QUERY',
    DELETE_NEW_QUESTION_PLAYGROUND_QUERIES = 'DELETE_NEW_QUESTION_PLAYGROUND_QUERIES',
    TOGGLE_CONFIRMATION_MODAL = 'TOGGLE_CONFIRMATION_MODAL',
    ASK_AI_PLAYGROUND_QUESTIONS_STARTED = 'ASK_AI_PLAYGROUND_QUESTIONS_STARTED',
    ASK_AI_PLAYGROUND_QUESTIONS_SUCCESSFUL = 'ASK_AI_PLAYGROUND_QUESTIONS_SUCCESSFUL',
    ASK_AI_PLAYGROUND_QUESTIONS_FAILED = 'ASK_AI_PLAYGROUND_QUESTIONS_FAILED',
    UPDATE_CORRECT_PLAYGROUND_QUERIES = 'UPDATE_CORRECT_PLAYGROUND_QUERIES',
    SET_IS_FILTERING_SELECTED_QUERIES = 'SET_IS_FILTERING_SELECTED_QUERIES',
    RESET_SELECTED_QUERIES = 'RESET_SELECTED_QUERIES',
    RESET_SELECTED_QUERIES_RESULTS = 'RESET_SELECTED_QUERIES_RESULTS',
    SET_PLAYGROUND_ANSWER_HIGHLIGHT_INDEXES = 'SET_PLAYGROUND_ANSWER_HIGHLIGHT_INDEXES',
    SET_SELECTED_AI_PLAYGROUND_TAB = 'SET_SELECTED_AI_PLAYGROUND_TAB',
    UPDATE_PLAYGROUND_TAB = 'UPDATE_PLAYGROUND_TAB',
    FETCH_ALL_PREVIOUS_PLAYGROUND_QUESTIONS_AND_ANSWERS_STARTED = 'FETCH_ALL_PREVIOUS_PLAYGROUND_QUESTIONS_AND_ANSWERS_STARTED',
    FETCH_ALL_PREVIOUS_PLAYGROUND_QUESTIONS_AND_ANSWERS_SUCCESSFUL = 'FETCH_ALL_PREVIOUS_PLAYGROUND_QUESTIONS_AND_ANSWERS_SUCCESSFUL',
    FETCH_ALL_PREVIOUS_PLAYGROUND_QUESTIONS_AND_ANSWERS_FAILED = 'FETCH_ALL_PREVIOUS_PLAYGROUND_QUESTIONS_AND_ANSWERS_FAILED',
    TOGGLE_PREVIOUSLY_ASKED_QUESTION = 'TOGGLE_PREVIOUSLY_ASKED_QUESTION',
    SET_IS_FILTERING_PREVIOUSLY_ASKED_QUERIES = 'SET_IS_FILTERING_PREVIOUSLY_ASKED_QUERIES',
    UPDATE_AI_PREVIOUSLY_ASKED_QUERIES_SEARCH = 'UPDATE_AI_PREVIOUSLY_ASKED_QUERIES_SEARCH',
    SET_SELECTED_PREVIOUS_QUESTIONS_TAB = 'SET_SELECTED_PREVIOUS_QUESTIONS_TAB'
}

export interface MLTestDocumentTable {
    mlTestDocumentId: number;
    location: string;
    documentDescription: string;
    mimeType: string;
    documentNameId: number | null;
    documentName: string;
}

export interface MLTestDocument {
    mlTestDocumentId: number;
    location: string;
    documentDescription: string;
    documentNameId: number | null;
    mimeType: string;
    scheduleStartPage: number | null;
    scheduleEndPage: number | null;
    agreementTypeId: number;
    agreementType: AgreementType;
    documentName: string;
    inProgress: number | null;
}

export interface FileWithDocumentNameId {
    documentNameId: number | null;
    documentDescription: string;
}

export interface SystemIdInfo {
    systemId: string;
    type: SingleDatasetFieldType;
    isMultiSelect: boolean;
    dropdownListId: number | null;
}

export interface SystemIdInfoUI extends Omit<SystemIdInfo, 'type'> {
    type: SingleDatasetFieldType | null;
}

export interface PlaygroundQuestion {
    documentQueryId?: number;
    question: string;
    queryKey: string;
    guidanceNotes: string;
    correct: boolean;
}

export interface AIPlaygroundRequest {
    mlTestDocumentId: number;
    scheduleStartPage: number;
    scheduleEndPage: number;
    questions: PlaygroundQuestion[];
}

export interface AIPlaygroundConfirmationRequest {
    mlTestDocumentExtractId: number;
    correct: PlaygroundQuestion[];
}

export interface QuestionsAndAnswers extends PlaygroundQuestion {
    answer: MLPageData;
}

export enum AIPlaygroundTab {
    ACTIVE_AI_QUESTIONS = 'Active AI Questions',
    PREVIOUSLY_ASKED_QUESTIONS = 'Previously Asked Questions',
    CONFIRMATION = 'Confirmation'
}

export enum PreviousQuestionsTab {
    CORRECT = 'Correct Queries',
    INCORRECT = 'Incorrect Queries'
}

export interface PreviouslyAskedQuestions {
    mlTestDocumentId: number;
    questionsAndAnswers: QuestionsAndAnswers[]
}

export interface AllPreviousPlaygroundQuestionsAndAnswers {
    documentNameId: number;
    previouslyAskedQuestions: PreviouslyAskedQuestions[];
}

export interface AdminAIPlaygroundState {
    isFetchingMLTestDocuments: boolean;
    mlTestDocuments: MLTestDocumentTable[];
    mlTestDocumentsTotal: number;
    mlDocumentsTableFilters: TableFilters;
    mlDocumentsTablePageNumber: number;
    mlDocumentsTableColumnSort: ColumnSort | undefined;
    mlDocumentsTablePageSize: number;
    mlTestDocumentsUploadModalOpen: boolean;
    isUploadingMLTestDocument: boolean;
    filesToUpload: File[] | null;
    fileDocumentNameIds: FileWithDocumentNameId[];
    isOpening: boolean;
    mlTestDocumentUrl: null | string;
    mlTestDocument: MLTestDocument | null;
    mlTestDocumentAnalysisView: AnalysisView;
    aiPlaygroundSearchTerm: string;
    selectedPage: number | null;
    selectedQueries: PlaygroundQuestion[];
    currentSelectedQueries: PlaygroundQuestion[];
    currentCorrectQueries: number[];
    confirmationModalVisible: boolean;
    isAskingAIPlaygroundQuestions: boolean;
    aiResults: MLData | null;
    mlTestDocumentExtractId: number | null;
    isPlaygroundSection: boolean;
    isFilteringQuerySelection: boolean;
    selectedAIPlaygroundTab: AIPlaygroundTab;
    proposedAIPlaygroundTab: AIPlaygroundTab | null;
    isFetchingAllPreviousQuestionsAndAnswers: boolean;
    allPreviousQuestionsAndAnswers: AllPreviousPlaygroundQuestionsAndAnswers | null;
    previouslyAskedQueriesSearchTerm: string;
    selectedPreviousQuestionsTab: PreviousQuestionsTab;
}
